import axiosInstance from 'src/utils/axiosInstance';
import UrlConstants from 'src/constants/urlConstants';

const UPDATE_AGENT_PATH = UrlConstants().UPDATE_AGENT_PATH;
const ADD_NEW_AGENT_PATH = UrlConstants().ADD_NEW_AGENT_PATH;

export const createAgent = params =>
  axiosInstance.post(ADD_NEW_AGENT_PATH, params);

export const updateAgent = params =>
  axiosInstance.patch(`${UPDATE_AGENT_PATH}${params.id}.json`, params, {
    withCredentials: true,
  });

export const deleteAgent = params =>
  axiosInstance.delete(`${UPDATE_AGENT_PATH}${params.id}`);

export const validateAgent = param =>
  axiosInstance.post(`${UPDATE_AGENT_PATH}validate`, param);
